// Turn an Enedis yearly CAR value into base / HP-HC values, clamping up to the provider minimum.
// Used for FR + CDF only (the caller decides by passing `minimumCar` or null): when Enedis
// returns a value below the provider minimum while the known history reaches at least 365 days,
// the CAR is raised to that minimum. The HP/HC split uses a 65/35 ratio in both cases. The value
// stays editable via "Modifier la CAR".
export const clampCarMessage = minimumCar =>
  'Les données Enedis sont trop faibles, nous avons utilisé le minimum autorisé en remplacement (' +
  parseInt(minimumCar) +
  ' kWh)'

export default function clampEnedisCarToMinimum({ carValue, minimumCar, numberOfDays }) {
  const value = parseInt(carValue)
  let carBase = value
  let carHp = parseInt(value * 0.65)
  let carHc = value - carHp
  let clamped = false

  const min = parseInt(minimumCar)
  // The callers only reach this point when the Enedis value is > 0, so a value below the minimum
  // means a genuinely low CAR (e.g. yearlyExtrapolation of 1 kWh) that must be raised to the floor.
  if (min && numberOfDays >= 90 && value > 0 && value < min) {
    carBase = min
    carHp = parseInt(min * 0.65)
    carHc = min - carHp
    clamped = true
  }

  return { carBase, carHp, carHc, clamped }
}
